$('.block-product-card').each(function() {

    var card = $(this);

    // Add text link
    var link = card.find('.btn-text-link');
        card.find('.content').append(link);

    // Keep first element, wrap everything else
    card.find('.content').children().slice(1).wrapAll('<div class="hidden-content" />');

    card.mouseenter(function() {
        card.find('.hidden-content').slideDown(400);
    });

    card.mouseleave(function() {
        if (!card.hasClass('swiper-slide-active')) {
            card.find('.hidden-content').slideUp(400);
        }
    });

});
